import { render, staticRenderFns } from "./FormNew.vue?vue&type=template&id=4c973914&"
import script from "./FormNew.vue?vue&type=script&lang=js&"
export * from "./FormNew.vue?vue&type=script&lang=js&"
import style0 from "./FormNew.vue?vue&type=style&index=0&id=4c973914&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports